import React from 'react';
import DashboardCard from './DashboardCard';

const ContentLibraryCard = ({ data }) => {
    if (!data) return null;

    const { content } = data;

    return (
        <DashboardCard
            title="Content Library"
            icon="fas fa-book"
        >
            <div className="row mb-3">
                <div className="col-6">
                    <div className="text-center p-3 bg-dark rounded">
                        <div className="fs-2 fw-bold text-primary">{content.moviesTotal}</div>
                        <div className="text-light small">Movies</div>
                    </div>
                </div>
                <div className="col-6">
                    <div className="text-center p-3 bg-dark rounded">
                        <div className="fs-2 fw-bold text-info">{content.versionsTotal}</div>
                        <div className="text-light small">Versions</div>
                    </div>
                </div>
            </div>

            {content.recentlyAdded > 0 && (
                <div className="text-center mb-3 p-2 bg-dark rounded">
                    <div className="text-success">
                        <span className="fas fa-plus-circle me-2" />
                        <span className="fw-bold">{content.recentlyAdded}</span> added in last 7 days
                    </div>
                </div>
            )}

            {content.byStatus && Object.keys(content.byStatus).length > 0 && (
                <div>
                    <div className="text-light small mb-2 fw-bold">By Status</div>
                    <div className="row g-2">
                        {Object.entries(content.byStatus).map(([status, count]) => (
                            <div key={status} className="col-6">
                                <div className="d-flex justify-content-between align-items-center p-2 bg-dark rounded">
                                    <span className="text-light small text-capitalize">{status}</span>
                                    <span className="badge bg-primary text-black">{count}</span>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </DashboardCard>
    );
};

export default ContentLibraryCard;
